import React, { useContext, useState, useEffect } from "react";
import { Container, Col, Button, Row } from "react-bootstrap";
import "./ServiceRequestReadOnly.scss";
import { useHistory } from "react-router-dom";
// import { TabView, TabPanel } from "primereact/tabview";
import { Paginator } from "primereact/paginator";
import { useQuery, gql, useMutation, useLazyQuery } from "@apollo/client";
import { MyContext } from "../Dashboard/Dashboard";
import Loader from "react-loader-spinner";
import moment from "moment";

import ReactTooltip from "react-tooltip";
const ServiceRequestReadOnly = (props) => {
  let { setServiceRecordList, vesselIMO, vesselImage, vesselName } =
    useContext(MyContext);
  let history = useHistory();
  const {
    match: { params },
  } = props;
  const { cid, vid } = params;
  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(10);
  const [serviceDetailList, setServiceDetails] = useState([]);
  const [paginationOption, setpaginationOption] = useState([10, 20, 30]);
  const [userRole, setUserRole] = useState("");
  const [disableButton, setDisableRequestButton] = useState(false);
  const [noData, setNoData] = useState(false);
  const [requestListStatus, setRequestListStatus] = useState(null);
  const [showPendingTab, setShowPendingTab] = useState(false);
  const [showTabs, setShowTabs] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [pendingCount, setPendingCount] = useState(0);
  const [allCount, setAllCount] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const pageLength = () => {
    if (serviceDetailList.length > 10) {
      setpaginationOption([10, 20, 30]);
    } else {
      setpaginationOption([10]);
    }
  };

  useEffect(() => {
    setFirst(1);
    setRows(10);
    getRequestList();
    getCurrentUserRole();
  }, []);
  useEffect(() => {
    if (!isInitialLoad && requestListStatus !== null) {
      getRequestList();
    }
  }, [requestListStatus]);
  useEffect(() => { }, [vesselIMO]);
  useEffect(() => { }, [vesselImage]);
  useEffect(() => { }, [vesselName]);

  const onPageChange = (event) => {
    setFirst(event.page + 1);
    setRows(event.rows);
  }; 

  const getDateFormat = (date) => {
    return moment.utc(date).local().format("DD-MM-YYYY HH:mm:ss a");
  };

  const list_query = gql`
  query
  {serviceRequestListByVesselParty
    (vesselId:${vid},
      custId:${cid},
      pageNumber:${first},
      pageSize:${rows},
      serviceRequestTypeCode:"RAR",
      requestListStatus:${requestListStatus
      ? `"${requestListStatus}"`
      : "null"
    })
  {
    requests {
      requestId
      serviceRequestTypeCode
      approverRoleCode
      approverRoleName
      title
      description
      createdDate
      workflow
      equipment
      status
      isWarrantyEnabled
      estimateStartDate
      estimateEndDate
      customer
      vessel
      isAssignee
      currentAssigneeJob 
    }
    isPendingOnly
    totalCount 
  }
}`;

  const [getRequestList, { loading, error, data }] = useLazyQuery(list_query, {
    fetchPolicy: "cache-and-network",
    onCompleted(resp) {
      const response = resp.serviceRequestListByVesselParty;
      const requests = response.requests || [];
      setServiceDetails(requests);
      setTotalRecords(response.totalCount);
      // Only first load should decide tab visibility
      if (isInitialLoad) {
        setShowTabs(response.isPendingOnly);
         
        if (response.isPendingOnly) {
          setPendingCount(response.totalCount);
          setRequestListStatus("Pending");
        } else {
          setAllCount(response.totalCount);
          setRequestListStatus("All");
        }

        setIsInitialLoad(false);
      }
      // Update counts whenever user switches tabs
      if (requestListStatus === "Pending") {
        setPendingCount(response.totalCount);
      }

      if (requestListStatus === "All") {
        setAllCount(response.totalCount);
      }
    },
    onError(error) { },
  });

  const goToServiceDetailswithID = (service) => {
    setServiceRecordList(service);
    localStorage.setItem("singleRequest", service);
    history.push(
      `/customers/${cid}/vessel/${vid}/operations/serviceRequest/serviceDetails/${service.requestId}`,
    );
  };

  const goToNewServiceRequest = () => {
    history.push(
      `/customers/${cid}/vessel/${vid}/operations/serviceRequest/newServiceRequest`,
    );
  };
  const handleAllClick = () => {
    setRequestListStatus("All");
  };

  const handlePendingClick = () => {
    setRequestListStatus("Pending");
  };
  const getCurrentUserRole = () => {
    setUserRole(localStorage.getItem("role"));
    setDisableRequestButton(true);
  };

  const goToVesselList = () => {
    history.push(`/customers/${cid}/vessel`);
  };

  const printStatus = (service) => {
    let status = service.status;
    let workflow = service.workflow;
    if (service.currentAssigneeJob !== "Service Engineer") {
      if (service.approverRoleName !== null) {
        return (
          <div class="statusMsg">
            <span className="">
              {workflow}: {status}{" "}
            </span>{" "}
            <br></br>
            <span className="pending">
              Pending with {service.approverRoleName}{" "}
              {service.workflow === "Access Request Raised"
                ? " for approval."
                : null}{" "}
            </span>
          </div>
        );
      } else {
        return (
          <div class="statusMsg">
            <span className="">
              {workflow}: {status}{" "}
            </span>{" "}
            <br></br>
            <span className="pending">Pending</span>
          </div>
        );
      }
    } else {
      let today = moment();
      let start = service.estimateStartDate;
      let end = service.estimateEndDate;

      if (today.isBefore(start, "second")) {
        if (status == "Cancelled") {
          return (
            <div class="statusMsg">
              <span className="">
                {workflow}: {status}{" "}
              </span>{" "}
              <br></br>
              <span className="cancel"> Cancelled</span>
            </div>
          );
        } else {
          return (
            <div class="statusMsg">
              <span className="">
                {workflow}: {status}{" "}
              </span>{" "}
              <br></br>
              <span className="pending">
                Pending with {service.currentAssigneeJob}{" "}
              </span>
            </div>
          );
        }
      } else if (today.isAfter(end, "second")) {
        return (
          <div class="statusMsg">
            <span className="">
              {workflow}: {status}{" "}
            </span>{" "}
            <br></br>
            <span>Ended</span>
          </div>
        );
      } else {
        if (status == "Cancelled") {
          return (
            <div class="statusMsg">
              <span className="">
                {workflow}: {status}
              </span>{" "}
              <br></br>
              <span className="cancel"> Cancelled</span>
            </div>
          );
        } else {
          return (
            <div class="statusMsg">
              <span className="">
                {workflow}: {status}
              </span>{" "}
              <br></br>
              <span className="active">Active</span>
            </div>
          );
        }
      }
    }
  };

  return (
    <div className="customers service-request-wrapper">
      <div className="header-section">
        <h5>TRITON Reporter</h5>
        <div className="title">
          <div className="welcome">
            <div className="user-box">
              {localStorage.getItem("vesselImage") &&
                localStorage.getItem("vesselImage") !== "null" ? (
                <img src={localStorage.getItem("vesselImage")} alt="" />
              ) : (
                <img src="user-icon" alt="" />
              )}
            </div>
            <div className="vessel-name">
              {localStorage.getItem("vesselName")}
            </div>
            {localStorage.getItem("vesselIMO") &&
              localStorage.getItem("vesselIMO") !== "null" ? (
              <div className="vessel-number">
                IMO : {localStorage.getItem("vesselIMO")}
              </div>
            ) : (
              <div className="vessel-number">IMO : N.A</div>
            )}
          </div>
          <div className="sub-header">Service Requests</div>
        </div>
      </div>

      <div className="service-request">
        {showTabs && (<div className="request-tabs-header">
          <div
            className={`request-tab ${requestListStatus === "Pending" ? "active" : ""
              }`}
            onClick={handlePendingClick}
          >
            Pending
            {requestListStatus === "Pending" && pendingCount != 0 && <span className="request-count">
              {pendingCount > 999 ? '999+' : pendingCount}
            </span>}
          </div>

          <div
            className={`request-tab ${requestListStatus === "All" ? "active" : ""
              }`}
            onClick={handleAllClick}
          >
            All
            {allCount != 0 && <span className="request-count">
              {allCount > 999 ? '999+' : allCount}
            </span>}
          </div>
        </div>)}

        {loading && (
          <div className="loader">
            <Loader
              type="TailSpin"
              color="#2546B1"
              height={80}
              width={80}
              timeout={3000}
            />
          </div>
        )}

        {!loading && (
          <Container fluid="md">
            {serviceDetailList.length > 0 ? (
              serviceDetailList.map((service, i) => (
                <Row
                  className="service-request-details-chief-engineer"
                  key={i}
                  onClick={() => goToServiceDetailswithID(service)}
                >
                  <Col className="row-details p-3">
                    <div className="general-description">
                      {service.isWarrantyEnabled && (
                        <span
                          data-tip
                          data-for={`warranty-tooltip-${service.id}`}
                          className="warranty-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                          }}
                          onMouseDown={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <i className="pi pi-shield"></i>
                          <i className="pi pi-check"></i>

                          <ReactTooltip
                            id={`warranty-tooltip-${service.id}`}
                            type="dark"
                            effect="float"
                            place="right"
                          >
                            Under Warranty
                          </ReactTooltip>
                        </span>
                      )}

                      <span title={`Request was created on : ${getDateFormat(service.createdDate)}`}>
                        {service.title}
                      </span>
                    </div>

                    <div className="specific-details">
                      <div className="requestStyle">
                        {service.equipment}
                      </div>

                      <div className="date-container">
                        <div className="request-timestamp dateStyle">
                          {getDateFormat(service.estimateStartDate)}
                        </div>

                        <div
                          className="arrow-between arrow-triangle"
                          aria-hidden="true"
                        />

                        <div
                          className={`request-timestamp dateStyle ${service.status === "Completed" &&
                            service.workflow === "Request Approval"
                            ? "is-completed"
                            : ""
                            }`}
                        >
                          {getDateFormat(service.estimateEndDate)}
                        </div>
                      </div>

                      <div className="request-status">
                        {printStatus(service)}
                      </div>
                    </div>
                  </Col>
                </Row>
              ))
            ) : (
              <div className="no-record">No Records Found</div>
            )}
          </Container>
        )}
      </div>

      <div className="service-request-remote-access-list">
        <div className="card">
          <Paginator
            first={(first - 1) * rows}
            rows={rows}
            className="service-request-paginator"
            totalRecords={totalRecords}
            rowsPerPageOptions={paginationOption}
            onPageChange={onPageChange}
          />
        </div>
        <Button
          className="request-access-button"
          onClick={() => goToNewServiceRequest()}
          style={{ display: "none" }}
        >
          Raise Request
        </Button>
      </div>
    </div>
  );
};

export default ServiceRequestReadOnly;
